import React from 'react';
// import FAQs from 'dummy/categories';
import {FairBox} from 'components/fair';
import {connect} from 'react-redux';
import {Fairs} from 'base/api';
import axios from 'axios';
import {toastr} from 'react-redux-toastr';
import {Link, withRouter} from 'react-router-dom';
import _FairDetail from './_FairDetail.scss';
import * as actions from 'actions/fairs';
import ProductItem from './ProductItem.jsx';
import moment from 'moment';
import FairInfo from './FairInfo.jsx';
import ReactPaginate from 'react-paginate';
import cookie from 'react-cookie';


class FairDetail extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      access_token: cookie.load('accessToken') || '',
      total: 0,
      totalRating: 0,
      pageCount: 0,
      pageCountRating: 0,
      limit: 5,
      offset: 0,
      offsetRating: 0,
      API_URL: '',
      data: {},
      listProductOrderTimes: [],
      listProductRatingPoint: []
    }
    this.handlePageClick= this.handlePageClick.bind(this)
    this.handlePageRatingClick = this.handlePageRatingClick.bind(this)
  }

  handlePageRatingClick(data) {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.state.limit);

    this.setState({offsetRating: offset}, () => {
      this.loadProductsRating();
    });
  };

  handlePageClick(data) {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.state.limit);

    this.setState({offset: offset}, () => {
      this.loadProducts();
    });
  };

  componentDidMount() {
    let params = {
      filter: {
        include: ['categories']
      }
    }
    Fairs.actions.get.request({id: this.props.match.params.id}, params).then(response => {
      this.props.dispatch({type: 'UPDATE_CATEGORIES_OF_FAIR', data: response.data.fair.categories})
      this.setState({
        data: response.data,
        API_URL: response.data.fair.apiUrl
      }, () => {if (response.data.statistic.total_approved_products > 0) {this.loadProducts(); this.loadProductsRating()}})
    })
  }

  loadProducts() {
    let params = {
      filter: {
        status: 1,
        limit: this.state.limit,
        offset: this.state.offset,
        order : 'totalOrderTimes DESC'
      }
    }
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/products/approved/count`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      if (response.data && response.data.total > 0) {
        this.setState({total: response.data.total, pageCount: Math.ceil(response.data.total / this.state.limit)}, () => {
          axios({
            method: 'GET',
            url:`${this.state.API_URL}/products`,
            headers: {
              Authorization: `${this.state.access_token}`
            },
            params
          }).then(response => {
            if (response.data) {
              this.setState({
                listProductOrderTimes: response.data
              })
            }
          }).catch(error => {
            console.log(error)
          })
        })
      }
    }).catch(error => {
      console.log(error)
    })
  }

  loadProductsRating() {
    let params = {
      filter: {
        status: 1,
        limit: this.state.limit,
        offset: this.state.offsetRating,
        order : 'averageRatingPoint DESC'
      }
    }
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/products/approved/count`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      if (response.data && response.data.total > 0) {
        this.setState({totalRating: response.data.total, pageCountRating: Math.ceil(response.data.total / this.state.limit)}, () => {
          axios({
            method: 'GET',
            url:`${this.state.API_URL}/products`,
            headers: {
              Authorization: `${this.state.access_token}`
            },
            params
          }).then(response => {
            if (response.data) {
              this.setState({
                listProductRatingPoint: response.data
              })
            }
          }).catch(error => {
            console.log(error)
          })
        })
      }
    }).catch(error => {
      console.log(error)
    })
  }

  render() {
    let Fair = this.state.data.fair ? this.state.data.fair : {};
    let Categories = Fair.categories && Fair.categories.map((item, index) => {
      if(index === 0) {return item.name} else {return ' - ' + item.name}
    })
    let Statistic = this.state.data && this.state.data.statistic ? this.state.data.statistic : {};
    let TopProductByOrder = this.state.listProductOrderTimes.map(item => {
      return (
        <ProductItem product={item} type='topOrder'/>
      )
    })
    let TopProductByRating = this.state.listProductRatingPoint.map(item => {
      return (
        <ProductItem product={item} type='topRating'/>
      )
    })
    return (
      <div>
        <FairInfo data={Fair}/>
        <div className='fair-box-content list-item'>
          <div className='item-detail'>
            <Link to={`/fair/${Fair.id}/businesses`}>
              <p className='title'>Số lượng doanh nghiệp</p>
              <p className='value'>{Statistic.total_approved_businesses || 0}</p>
            </Link>
          </div>
          <div className='item-detail'>
            <Link to={`/fair/${Fair.id}/products`}>
              <p className='title'>Số lượng sản phẩm</p>
              <p className='value'>{Statistic.total_approved_products || 0}</p>
            </Link>
          </div>
          <div className='item-detail'>
            <Link to={`/fair/${Fair.id}/orders`}>
              <p className='title'>Số lượng đơn hàng</p>
              <p className='value'>{Statistic.total_orders || 0}</p>
            </Link>
          </div>
          <div className='item-detail'>
            <Link to={`/fair/${Fair.id}/businesses/awaiting`}>
              <p className='title'>Doanh nghiệp chờ duyệt</p>
              <p className='value'>{Statistic.total_awaiting_businesses || 0}</p>
            </Link>
          </div>
          <div className='item-detail'>
            <Link to={`/fair/${Fair.id}/products/awaiting`}>
              <p className='title'>Sản phẩm chờ duyệt</p>
              <p className='value'>{Statistic.total_awaiting_products || 0}</p>
            </Link>
          </div>
        </div>
        { this.state.listProductOrderTimes && this.state.listProductOrderTimes.length > 0 && (
          <div className='fair-box-content list-product'>
            <h3 className='text-center title-content'>Top sản phẩm bán chạy</h3>
            <div className='list-product'>
              {TopProductByOrder}
            </div>
            {this.state.total > 5 && (
              <div className='wrap-pagination'>
                <ReactPaginate previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={<a href="">...</a>}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"} />
              </div>
              )}
          </div>
        )}

        { this.state.listProductRatingPoint && this.state.listProductRatingPoint.length > 0 && (
          <div className='fair-box-content list-product'>
            <h3 className='text-center title-content'>Top sản phẩm yêu thích</h3>
            <div className='list-product'>
              {TopProductByRating}
            </div>
            {this.state.totalRating > 5 && (
              <div className='wrap-pagination'>
                <ReactPaginate previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={<a href="">...</a>}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCountRating}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageRatingClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"} />
              </div>
              )}
          </div>
        )}

      </div>
    );
  }
}

export default connect()(withRouter(FairDetail));



// WEBPACK FOOTER //
// ./components/fair/FairDetail.jsx